export {
  createAuthContext,
  type AuthConfig,
  type AuthContextType,
  type AuthUser,
  type AuthAuditLog,
} from './createAuthContext';

// Re-export FirebaseUser type for consumers
export type { User as FirebaseUser } from 'firebase/auth';
